import useWindowSize from "../../utils/useWindowSize";

function useMapHeight() {
  const windowSize = useWindowSize();
  return windowSize.width < 900 ? 300 : windowSize.width < 1400 ? 500 : 700;
}

export default useMapHeight;
